module.exports = __webpack_public_path__ + "assets/img/mach-ii.8a0b2b95.png";